import { motion } from "framer-motion";
import { BeeMark } from "./Logo";

export function FloatingBee({ className = "" }) {
    return (
        <motion.div
            aria-hidden="true"
            className={`pointer-events-none absolute ${className}`}
            animate={{ y: [0, -12, 0], rotate: [0, 6, 0] }}
            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
        >
            <BeeMark className="h-14 w-14 drop-shadow-md" />
        </motion.div>
    );
}

export function FlightPath({ className = "" }) {
    return (
        <svg
            viewBox="0 0 300 200"
            fill="none"
            aria-hidden="true"
            className={`text-honey/50 ${className}`}
        >
            <path
                d="M10 180 C 80 120, 60 60, 150 70 S 280 130, 290 30"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                className="flight-path"
            />
        </svg>
    );
}

export function HexPattern({
    className = "",
    stroke = "#F59E0B",
    opacity = 0.12,
    rows = 7,
    cols = 14,
    size = 26,
    strokeWidth = 2,
}) {
    const w = Math.sqrt(3) * size;
    const vStep = size * 1.5;
    const hexes = [];
    for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
            const cx = c * w + (r % 2 ? w / 2 : 0);
            const cy = r * vStep + size;
            const pts = Array.from({ length: 6 }, (_, i) => {
                const a = (Math.PI / 180) * (60 * i - 30);
                return `${(cx + size * Math.cos(a)).toFixed(1)},${(
                    cy +
                    size * Math.sin(a)
                ).toFixed(1)}`;
            }).join(" ");
            hexes.push(
                <polygon
                    key={`${r}-${c}`}
                    points={pts}
                    fill="none"
                    stroke={stroke}
                    strokeOpacity={opacity}
                    strokeWidth={strokeWidth}
                />,
            );
        }
    }
    return (
        <svg
            className={className}
            viewBox={`0 0 ${cols * w} ${rows * vStep + size * 2}`}
            preserveAspectRatio="xMidYMid slice"
            aria-hidden="true"
        >
            {hexes}
        </svg>
    );
}

export function RotatingBadge({ className = "" }) {
    return (
        <div className={`relative ${className}`}>
            <svg
                viewBox="0 0 120 120"
                className="h-full w-full animate-[spin-slower_18s_linear_infinite]"
                aria-hidden="true"
            >
                <defs>
                    <path
                        id="badge-circle"
                        d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0"
                    />
                </defs>
                <text
                    className="fill-ink font-display text-[11.5px] font-semibold"
                    style={{ letterSpacing: "0.18em" }}
                >
                    <textPath href="#badge-circle">
                        NOW ENROLLING • NOW ENROLLING • NOW ENROLLING •
                    </textPath>
                </text>
            </svg>
            <BeeMark className="absolute inset-0 m-auto h-9 w-9" />
        </div>
    );
}

export function Wave({ className = "", fill = "#FFF9E6" }) {
    return (
        <div className={className} aria-hidden="true">
            <svg
                viewBox="0 0 1440 70"
                preserveAspectRatio="none"
                className="block h-[44px] w-full sm:h-[64px]"
            >
                <path
                    d="M0,40 C180,70 360,10 540,24 C720,38 900,66 1080,50 C1260,36 1350,20 1440,30 L1440,70 L0,70 Z"
                    fill={fill}
                />
            </svg>
        </div>
    );
}
